"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModelClient = void 0;
const domain_client_1 = require("./domain-client");
const client_exception_1 = require("./exceptions/client-exception");
const model_factory_1 = require("./model-factory");
class ModelClient {
    constructor(baseUrl, apiKey, seed, portalMap) {
        if (!baseUrl || !seed) {
            return;
        }
        this.modelFactory = new model_factory_1.ModelFactory(portalMap);
        this.domainClient = new domain_client_1.DomainClient(baseUrl, apiKey, this.getModelName(), this.getVersion(), this.isPublic(), seed);
    }
    async fetch(id) {
        const modelDescriptions = await this.fetchDescription(id);
        return this.modelFactory.fromDescription(modelDescriptions);
    }
    async fetchDescription(id) {
        if (!this.domainClient) {
            throw new client_exception_1.ClientException("Offline mode active: did you provide all parameters " +
                "in the constructor?");
        }
        const result = await this.domainClient.doRequest([id]);
        return result[0];
    }
    async fetchMultiple(ids) {
        const descriptions = await this.fetchMultipleDescriptions(ids);
        return this.modelFactory.fromDescriptions(descriptions);
    }
    async fetchMultipleDescriptions(ids) {
        if (!this.domainClient) {
            throw new client_exception_1.ClientException('Offline mode active: did you provide all parameters ' +
                'in the constructor?');
        }
        return await this.domainClient.doRequest(ids);
    }
    fromDescription(description) {
        return this.modelFactory.fromDescription(description);
    }
    fromDescriptions(descriptions) {
        return this.modelFactory.fromDescriptions(descriptions);
    }
}
exports.ModelClient = ModelClient;
//# sourceMappingURL=model-client.js.map